
export default [{
    path: 'evaluationIndex',
    name: '测评系统',
    meta: {
        showFooter: true
    },
    component: () => import('../../views/evaluation/index.vue')
}];
